/**************************************************************
 * Hero Marquee
 **************************************************************/

function fnCustomCursor(  i, oContent ) {
    var oCursor 	= $(oContent);

    var oCursor = $("div.custom-cursor"),
        sOriginalCursorText = oCursor.html();

    //	Follow the cursor
    $('.full-screen-media').mousemove(function(e) {
        oCursor.css({
            top: e.clientY - oCursor.height() / 2,
            left: e.clientX - oCursor.width() / 2
        });
    });

    //	Hovering over any link

    $(".full-screen-media.has-video").mouseenter(function() {
        var sThisCursorLabel = $(this).attr('data-cursor');
        if (typeof sThisCursorLabel !== 'undefined' && sThisCursorLabel !== false) {
            oCursor.html(sThisCursorLabel);
        }
        $(this).css('cursor','none');
        oCursor.removeClass('small');
        $('html').addClass('has-custom-cursor');

    }).mouseleave(function() {
        oCursor.addClass('small');
        oCursor.html(sOriginalCursorText);
        $('html').removeClass('has-custom-cursor');
    });

    // $("header a, footer a").mouseenter(function() {
    //     var sThisCursorLabel = $(this).attr('data-cursor');
    //     if (typeof sThisCursorLabel !== 'undefined' && sThisCursorLabel !== false) {
    //         oCursor.html(sThisCursorLabel);
    //     }
    //     $(this).css('cursor','none');
    //     oCursor.addClass('outlined');
    //     oCursor.removeClass('small');
    // }).mouseleave(function() {
    //     oCursor.removeClass('outlined');
    //     oCursor.addClass('small');
    //     oCursor.html(sOriginalCursorText);
    // });


    //	When clicking
    // $(window).mousedown(function() {
    //     oCursor.addClass('small');
    // }).mouseup(function() {
    //     oCursor.removeClass('small');
    // });


}